import React, { useState, Fragment, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Badge,
} from "reactstrap";
import "./styles.scss";
import Login from "../Login/Login";
import Register from "../Register/Register";
import Auth from "../../config/auth";
import storeId from "../../config/storeId";


import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchViewCart } from "../../redux/actions/products";

const HeaderThemeTwo = (props) => {
  let history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [badge, setBadge] = useState("");
  const store = storeId();
  function handleLogout() {
    Auth.destroyToken();
    history.go("/");
  }

  useEffect(() => {
		props.fetchViewCart();
	}, []);

	useEffect(() => {
		if (props.carts.carts.data) {
			setBadge(
				Auth.isAuthenticated()
					? props.carts.carts.data.cart.items.length > 0
						? props.carts.carts.data.cart.items.length
						: 0
					: null
			);
		}
	}, [props.carts.carts]);

  return (
    <Fragment>
      <Navbar light expand="md navbar navbar-container">
        <NavbarBrand className="nav-brand">
          <Link to="/">{store}</Link>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="" navbar>
            <NavItem>
							<NavLink className="navLink">
								<Link to="/auction" className="link">AUCTION</Link>
							</NavLink>
						</NavItem>
          </Nav>
          <Nav className="ml-auto" navbar>
            <NavbarBrand className="nav-brand-desktop">
              <Link to="/">{store}</Link>
            </NavbarBrand>
          </Nav>
          <Nav className="ml-auto" navbar>
            <NavItem className="pr-3">
              <NavLink>
                <Link to="/search">
                  <i class="fa fa-search fa-lg" aria-hidden="true"></i>
                </Link>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink>
                <Link>
                  <i class="fa fa-shopping-bag fa-lg" aria-hidden="true"></i>
                </Link>
              </NavLink>
            </NavItem>
            <NavItem>
							<NavLink>
								<Link to="/cart">
									<div className="badge-cart">
										<i
											className="fa fa-shopping-cart fa-lg"
											aria-hidden="true"
										></i>
										<Badge color="danger" className="badge-count">
											{badge}
										</Badge>
									</div>
								</Link>
							</NavLink>
						</NavItem>
            {!Auth.isAuthenticated() && (
              <Fragment>
                
                <NavItem>
                  <NavLink>
                    <Login buttonLabel="Login" />
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink>
                    <Register buttonLabel="Register" />
                  </NavLink>
                </NavItem>
              </Fragment>
            )}
            {Auth.isAuthenticated() && (
              <Fragment>
                <NavItem>
						<NavLink>
							<Link to="/notifications">
								<div className="badge-cart">
									<i
										className="fa fa-bell fa-lg"
										aria-hidden="true"
									></i>
									<Badge color="danger" className="badge-count">
										{1}
									</Badge>
								</div>
							</Link>
						</NavLink>
					</NavItem>
          <NavItem>
						<NavLink>
							<Link to="/product-saved">
								<div className="badge-cart">
									<i
										className="fa fa-heart-o fa-lg"
										aria-hidden="true"
									></i>
								</div>
							</Link>
						</NavLink>
					</NavItem>
          <NavItem>
                <NavLink>
                  <Link onClick={handleLogout}>Logout</Link>
                </NavLink>
              </NavItem>
              </Fragment>
              
            )}
          </Nav>
        </Collapse>
      </Navbar>
    </Fragment>
  );
};

HeaderThemeTwo.propTypes = {
	carts: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
	carts: state.carts,
});

const pageActions = { fetchViewCart };
export default connect(mapStateToProps, pageActions)(HeaderThemeTwo);
